import { put, call, take, fork } from 'redux-saga/effects'
import generalSaga from '../general'
import { USER_PASSWORD_PUT } from '../../reducers/user-password/type'
import { userChangePasswordService } from '../../api/user-password'
import { userPasswordPutSuccess } from '../../reducers/user-password/action'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* userChangePasswordPutFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(userChangePasswordService, entity)

    yield put(userPasswordPutSuccess(response))
    yield put(operationSuccess())
    //window.location.href = '/set-password-success'

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* userChangePasswordPutWatcher() {
  while (true) {
    const action = yield take(USER_PASSWORD_PUT)
    const { payload } = action

    yield fork(generalSaga, userChangePasswordPutFlow, payload)
  }
}
